import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'ax-row-cell-view',
  templateUrl: 'row-cell-view.component.html',
  styleUrls: ['row-cell-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowCellViewComponent {}
